export const imageWidth = `64px`

export const institutionPath = '/uz'
